/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_No_RoundsInputs */



/**
* | output |
* | --- |
* | "No rounds played yet." |
*
* @param {Rounds_No_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_no_rounds = /** @type {((inputs?: Rounds_No_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_No_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ronde jouée pour le moment.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se han jugado rondas todavía.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma rodada jogada ainda.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun round giocato ancora.")
	return /** @type {LocalizedString} */ ("No rounds played yet.")
});